export type RequestQueryModel = {
  phoneNumberRange: string;
  name: string;
};

export const DefaultRequestQueryModel: RequestQueryModel = {
  phoneNumberRange: "",
  name: ""
};
